import { Card, Flex } from '@chakra-ui/react';
import { BaseButton } from '@cks-internal/react-base';
import { faCartPlus } from '@fortawesome/free-solid-svg-icons';
import { ProductMeta } from './ProductMeta';
import { ProductListingModel } from '../productView/models/ProductListingModel.ts';

type ProductItemProps = ProductListingModel & {
  onClickOrder?: () => void;
};

export const ProductItem = (props: ProductItemProps) => {
  const { Images, DrugName, onClickOrder, AvailableForms, Usages } = props;

  return (
    <Card.Root
      variant='outline'
      overflow='hidden'
      transition='all 0.2s'
      _hover={{ shadow: 'md', borderColor: 'blue.200' }}>
      <Card.Body p={{ base: '4', md: '5' }}>
        <Flex
          direction={{ base: 'column', md: 'row' }}
          align={{ base: 'stretch', md: 'center' }}
          justify='space-between'
          gap={{ base: '4', md: '6' }}>
          <ProductMeta name={DrugName} usages={Usages} image={Images[0]} forms={AvailableForms} />
          <Flex flexShrink={0} justify={{ base: 'flex-end', md: 'flex-start' }}>
            <BaseButton icon={faCartPlus} onClick={onClickOrder}>
              Add to Cart
            </BaseButton>
          </Flex>
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};
